import actions from './actions';
import initialState from '../initialState';

export const noticesReducer = (state = initialState.notices, action) => {
    switch (action.type) {
        case actions.VIEW_NOTICE_MODAL:
            return { ...state, viewNoticeModal: action.state.viewNoticeModal };
        case actions.ADD_NOTICE_MODAL:
            return { ...state, addNoticeModal: action.state.addNoticeModal };
        default:
            return { ...state };
    }
};

export default noticesReducer;
